import { render, staticRenderFns } from "./MessageFileForm.vue?vue&type=template&id=64b09a4a&"
import script from "./MessageFileForm.vue?vue&type=script&lang=js&"
export * from "./MessageFileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b09a4a')) {
      api.createRecord('64b09a4a', component.options)
    } else {
      api.reload('64b09a4a', component.options)
    }
    module.hot.accept("./MessageFileForm.vue?vue&type=template&id=64b09a4a&", function () {
      api.rerender('64b09a4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/MessageFileForm.vue"
export default component.exports